// extracted by mini-css-extract-plugin
export default {"powerplantImg":"PowerPlant_powerplantImg__qTXuJ"};